<template>

    <div class="dd-m-modal--simple-success__content">
        <h2 class="dd-m-modal--simple-success__title">E-mail registered successfully</h2>

        <button type="button"
                v-on:click="hide()"
                class="dd-m-button dd-m-button--default dd-m-button--assertive">
            Back
        </button>
    </div>

</template>
<script>
    export default {
        name: 'opt-in-subscribe-success',
        methods: {
            hide() {
                PubSub.publish('closeCustomNewsletterModal');

                setTimeout(() => {
                    PubSub.publish('updateCustomNewsletterModalStep', {step: 1});
                }, 160);
            }
        }
    }
</script>


// WEBPACK FOOTER //
// resources/site/js/components/opt-in/opt-in-subscribe-success.vue